<template>
    <div class="nav">
        <el-carousel :interval="5000" arrow="hover" height="1260px">
            <el-carousel-item v-for="item in navimgs" :key="item">
                <img :src="item.url" alt="" class="img-nav">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      navimgs: [
        {
          url: require("@/assets/images/img_11.jpg")
        },{
          url: require("@/assets/images/img_12.jpg")
        },
      ],
    };

  }
}
</script>

<style lang="less" scoped>
.img-nav {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>